module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="b-cost-codes">\n	<div class="b-cost-codes__item">\n		<div class="b-cost-codes__item-content flex-grid-container"></div>\n	</div>\n</div>';

}
return __p
}